import React, { useEffect, useState, useRef } from 'react';
const DAYS_ES = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
export function UrgencyTimer() {
  const [totalSeconds, setTotalSeconds] = useState(10 * 60);
  const currentDayRef = useRef(DAYS_ES[new Date().getDay()]);
  useEffect(() => {
    const interval = setInterval(() => {
      setTotalSeconds(prev => {
        if (prev <= 0) return 10 * 60;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return <div className="w-full max-w-[460px] mx-auto my-3 px-4 py-4 border-2 border-text-primary rounded-2xl bg-white text-center shadow-sm" style={{
    minHeight: '220px',
    contain: 'layout'
  }} data-id="element-253">
      <h3 className="text-base md:text-lg font-bold mb-1.5 leading-tight uppercase text-text-primary" data-id="element-254">
        OFERTA SOLO POR HOY
        <br data-id="element-255" />
        <span className="text-primary font-italic italic" data-id="element-256">
          {currentDayRef.current}
        </span>
      </h3>

      <p className="text-sm md:text-[15px] font-normal text-text-primary leading-snug mx-auto mb-2 max-w-[340px]" data-id="element-257">
        Tu lugar solo está reservado por{' '}
        <strong className="font-bold" data-id="element-258">10 minutos</strong>. Si no accedés tu
        descuento pasa a la siguiente persona.
      </p>

      <p className="text-sm font-normal mb-2 text-text-primary" data-id="element-259">
        La oferta se termina en:
      </p>

      <div className="flex justify-center gap-4" data-id="element-260">
        <div className="flex flex-col items-center" data-id="element-261">
          <div className="rounded-2xl bg-white border-[2.5px] border-primary flex items-center justify-center" style={{
          width: '80px',
          height: '64px'
        }} data-id="element-262">
            <span className="text-3xl md:text-4xl font-bold leading-none text-text-primary tabular-nums" data-id="element-263">
              {String(minutes).padStart(2, '0')}
            </span>
          </div>
          <span className="text-[11px] md:text-xs font-bold tracking-[2px] mt-1 text-text-secondary uppercase" data-id="element-264">
            MINUTOS
          </span>
        </div>

        <div className="flex flex-col items-center" data-id="element-265">
          <div className="rounded-2xl bg-white border-[2.5px] border-primary flex items-center justify-center" style={{
          width: '80px',
          height: '64px'
        }} data-id="element-266">
            <span className="text-3xl md:text-4xl font-bold leading-none text-text-primary tabular-nums" data-id="element-267">
              {String(seconds).padStart(2, '0')}
            </span>
          </div>
          <span className="text-[11px] md:text-xs font-bold tracking-[2px] mt-1 text-text-secondary uppercase" data-id="element-268">
            SEGUNDOS
          </span>
        </div>
      </div>
    </div>;
}